import { useEffect, useRef, useState } from "react";

const SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js";
let scriptPromise = null;
const loadTurnstileScript = () => {
  if (window.turnstile) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = SCRIPT_SRC;
      s.async = true;
      s.defer = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
};

// Widget Cloudflare Turnstile en mode Invisible (configuré côté dashboard
// Cloudflare, site key inchangée) : monté en permanence par l'appelant dès
// le chargement de la page. appearance:"interaction-only" garantit qu'aucune
// case à cocher ne s'affiche, sauf si Cloudflare juge une interaction
// nécessaire. Le jeton est obtenu automatiquement en arrière-plan
// (execution:"render" par défaut : pas d'appel .execute() manuel requis).
export default function TurnstileWidget({ onToken, resetSignal }) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    loadTurnstileScript().then(() => { if (!cancelled) setReady(true); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!ready || !containerRef.current || !window.turnstile) return;
    const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
    if (!siteKey) return;
    widgetIdRef.current = window.turnstile.render(containerRef.current, {
      sitekey: siteKey,
      appearance: "interaction-only",
      callback: (token) => onToken(token),
      "expired-callback": () => onToken(""),
      "error-callback": () => onToken(""),
    });
    return () => {
      if (widgetIdRef.current != null && window.turnstile) window.turnstile.remove(widgetIdRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready]);

  useEffect(() => {
    if (!resetSignal) return;
    if (widgetIdRef.current != null && window.turnstile) window.turnstile.reset(widgetIdRef.current);
    onToken("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetSignal]);

  return <div ref={containerRef} data-testid="turnstile-widget" className="my-3" />;
}
